import { call, put, takeLatest } from "redux-saga/effects";
import { GET_DASH_PATIENTS_DETAILS } from "../Constants";
import store from "../store"
import api from "../utils/apiRoutes"
import { getDashPatientDetailsRet } from "../actions/dashboardActions";
import Cookies from "js-cookie";

function* getPatientDetailsSage() {
    const  data = yield store.getState().dashboardStore.getPatientDetails
    const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get("token_medical_auth")}` } }
    try {          
        const apiData = yield call(api.dashboard.getPatientDetails, data, headers)
        if(apiData.success) {
            yield put(getDashPatientDetailsRet({
                success: true,
                data: apiData.data,
                message: apiData.message || "Data fetched Successful",
            }))
        }
        else {
            yield put(getDashPatientDetailsRet({
                success: false,
                message: "Invalid Request"
            }))
            // yield put(loginError())
        }

    } catch (error) {
        yield put(getDashPatientDetailsRet({
            success: false,
            message: "Invalid Request"
        }))
        // yield put(loginError())
    }
}


export const authSaga = [
    takeLatest(GET_DASH_PATIENTS_DETAILS, getPatientDetailsSage)
]

export default authSaga